{
    "ConfigureAgents_Add_Title": "Adicionar novo agente",
    "ConfigureAgents_Modify_Title": "Modificar agente",
    "ConfigureAgents_PromptMessage": "Tem a certeza de que pretende fechar esta janela? Todas as configurações modificadas serão perdidas ao fechá-la.",
    "ConfigureAgents_PromptConfirm": "Sim",
    "ConfigureAgents_PromptCancel": "Cancelar",
    "ConfigureAgents_Tabs_Details": "Detalhes do agente",
    "ConfigureAgents_Tabs_Advanced": "Avançado",
    "ConfigureAgents_Tabs_Omnichannel": "Omnicanal",
    "ConfigureAgents_Footer_Help": "Ajuda?",
    "ConfigureAgents_Footer_Submit": "Guardar",
    "ConfigureAgents_Footer_Cancel": "Cancelar",
    "NAME": "ConfigureAgents",
    "ConfigureAgents_Tabs_LinkedEntities": "Entidades Vinculadas"
}